import BitcoinBanner from "../../components/assets/bitBanner.png";
// import Dash from "../../components/assets/dashBanner.png";
import Litcoin from "../../components/assets/litBanner.png";
import EthBanner from "../../components/assets/ethBanner.png";
// import PaypalBanner from "../../components/assets/paypayBanner.png";
import UsdtBanner from "../../components/assets/usdtt.jpeg";
import BB from "../../components/assets/BTC.jpeg";
import BL from "../../components/assets/LTC.jpeg";
import BU from "../../components/assets/USDT.jpeg";
import BE from "../../components/assets/ETH.jpeg";

export const CryptoItems = [
  {
    id: 1,
    name: "Bitcoin",
    brate: 9123.18,
    srate: "Rate from API",
    short: "BTC",
    img: BitcoinBanner,
    address: "1Pj954PZatmiULxvdbMewewaAzoCPfr6hJ",
    barcode:BB
  },
  // {
  //   id: 2,
  //   name: "Dash",
  //   brate: 69.07 ,
  //   short: "DASH",
  //   srate: "Rate from API",
  //   img: Dash,
  //   address:"",
  //   // barcode:
  // },
  {
    id: 3,
    name: "Litecoin",
    brate: 42.12,
    short: "LTC",
    srate: "Rate from API",
    img: Litcoin,
    address:"LShptoMcCgdwFM17UTXYJAyYrkFLunXW8v",
    barcode: BL,
  },
  {
    id: 4,
    name: "Ethereum",
    brate: 233.95,
    short: "ETH",
    srate: "Rate from API",
    img: EthBanner,
    address:"0x1b156d28C4168556909Ca4eCbf5c40A7d2Af7df7",
    barcode: BE
  },
  {
    id: 5,
    name: "USDT",
    brate: "Not Available",
    short: "USDT",
    srate: "Rate from API",
    img: UsdtBanner,
    address:"LShptoMcCgdwFM17UTXYJAyYrkFLunXW8v",
    barcode:BU
  },
  // {
  //   id: 5,
  //   name: "Paypal",
  //   brate: "Not Available",
  //   short: "PYL",
  //   srate: "Coming soon",
  //   img: PaypalBanner,
  //   address:"0x66b827643ffb070ed9dd05a4dd74db655312c412"
//   barcode: 
// },
  // {
  //   id: 6,
  //   name: "Amazon",
  //   short: "AMZ",
  //   brate: "No Price Yet!",
  //   srate: "Coming soon",
  //   img: AmazonBanner,
  //   address:""
  //   // barcode:
  // },
];
